<template>
  <router-view />
</template>

<script>
import LoginPage from "./views/LoginPage.vue";
export const url = "https://customer-dashboard.azurewebsites.net";
// export const url = "http://localhost:3000";
export default {
  name: "App",
  components: {
    LoginPage,
  },
};
</script>

<style>
</style>
